export default {
    // Header Section
    "discover_your": "अपने",
    "life_predictions": "जीवन की भविष्यवाणी",
    "future_unveiled_through_stars": "सितारों के माध्यम से भविष्य का खुलासा",
    "life_predictions_description": "वैदिक ज्योतिष और ग्रहों के विश्लेषण के आधार पर व्यापक जीवन भविष्यवाणी प्राप्त करें। सटीक ज्योतिषीय अंतर्दृष्टि के साथ अपने भविष्य के मील के पत्थर, प्रमुख जीवन घटनाओं, करियर विकास, विवाह का समय, धन संचय और आध्यात्मिक यात्रा को समझें।",

    // Service Information
    "enter_details_for_predictions": "जीवन भविष्यवाणी के लिए अपना विवरण दर्ज करें",
    "complete_life_predictions": "संपूर्ण जीवन भविष्यवाणी",
    "service_price": "सेवा मूल्य",
    "comprehensive_life_predictions_note": "आपकी भविष्य की जीवन घटनाओं और ज्योतिषीय मार्गदर्शन का विस्तृत विश्लेषण",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_destiny_influence": "आपके नाम की तरंगें आपके भाग्य और भविष्य के अवसरों को आकार देती हैं",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "स्त्री",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_future_insights": "ग्रहों की अवधि और भविष्य की भविष्यवाणियों की गणना के लिए आवश्यक",
    "time_of_birth": "जन्म समय",
    "exact_time_critical_for_predictions": "सटीक दशा गणना और भविष्यवाणियों के लिए सटीक समय आवश्यक",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "location_essential_for_predictions": "स्थान भविष्य की घटनाओं को प्रभावित करने वाली ग्रहों की स्थिति को प्रभावित करता है",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगू",
    "kannada": "कन्नड़",
    "language_note": "आपकी जीवन भविष्यवाणी चुनी गई भाषा में प्रदान की जाएगी",

    // Core Prediction Features
    "future_life_events_predictions": "भविष्य की जीवन घटनाओं की भविष्यवाणी",
    "career_success_timeline": "करियर सफलता की समयरेखा",
    "marriage_relationship_predictions": "विवाह और रिश्ते की भविष्यवाणी",
    "wealth_prosperity_forecast": "धन और समृद्धि का पूर्वानुमान",
    "health_longevity_insights": "स्वास्थ्य और दीर्घायु की अंतर्दृष्टि",
    "pdf_download": "व्यापक पीडीएफ रिपोर्ट",

    "what_you_get": "आपकी जीवन भविष्यवाणी में क्या शामिल है",
    "comprehensive_future_roadmap": "व्यापक भविष्य का रोडमैप",
    "major_life_events_timeline": "प्रमुख जीवन घटनाओं की समयरेखा",
    "planetary_influence_analysis": "ग्रहों के प्रभाव का विश्लेषण",
    "remedial_guidance_solutions": "उपचारात्मक मार्गदर्शन और समाधान",

    // Actions & Buttons
    "pay_and_generate_analysis": "मेरी जीवन भविष्यवाणी प्राप्त करें",
    "processing_payment": "भुगतान प्रसंस्करण",
    "processing_request": "भविष्यवाणी तैयार की जा रही है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "life_predictions_processing": "आपकी जीवन भविष्यवाणी हमारे विशेषज्ञ वैदिक ज्योतिषियों द्वारा तैयार की जा रही है। आपको अपनी भविष्य की जीवन घटनाओं और ब्रह्मांडीय समयरेखा में विस्तृत अंतर्दृष्टि प्राप्त होगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_24_hours_delivery_note": "आपकी विस्तृत जीवन भविष्यवाणी 24 घंटों के भीतर तैयार हो जाएगी",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूरी भविष्यवाणी इस पर भेजी गई",

    // What You'll Receive
    "what_youll_receive": "आपका जीवन भविष्यवाणी पैकेज",
    "detailed_life_predictions": "व्यापक जीवन भविष्यवाणी रिपोर्ट (पीडीएफ)",
    "future_events_timeline": "भविष्य की घटनाओं की समयरेखा और तारीखें",
    "career_marriage_wealth_predictions": "करियर, विवाह और धन की भविष्यवाणी",
    "planetary_periods_analysis": "ग्रहों की अवधि (दशा) विश्लेषण",
    "remedial_solutions_guidance": "उपचारात्मक समाधान और मार्गदर्शन",

    // Visual Content
    "sample_life_predictions": "नमूना जीवन भविष्यवाणी",
    "major_life_milestone": "प्रमुख जीवन मील का पत्थर",
    "sample_prediction_reading": "अगले 2-3 वर्षों में करियर की सफलता और विवाह की संभावनाएं",
    "sample_predictions_preview": "समयरेखा अंतर्दृष्टि के साथ आपकी व्यक्तिगत जीवन भविष्यवाणी का पूर्वावलोकन",
    "life_prediction_areas": "जीवन भविष्यवाणी क्षेत्र",

    // Life Area Types
    "career": "करियर",
    "marriage": "विवाह",
    "wealth": "धन",
    "family": "परिवार",
    "health": "स्वास्थ्य",
    "education": "शिक्षा",

    // Status & Processing
    "your_predictions_status": "आपकी जीवन भविष्यवाणी की स्थिति",
    "processing_your_predictions": "आपके भविष्य का विश्लेषण",
    "predictions_processing_message": "हमारे वैदिक ज्योतिष विशेषज्ञ आपकी जन्म कुंडली के आधार पर आपकी ग्रहों की अवधि की गणना कर रहे हैं और भविष्य की घटनाओं का विश्लेषण कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति में",
    "pending": "कतार में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_24_hours": "रिपोर्ट 24 घंटों के भीतर तैयार",

    // Support & Contact
    "contact_support": "ज्योतिष सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक जन्म विवरण पूरा करें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "भविष्यवाणी प्रसंस्करण असफल। हमारी सहायता टीम से संपर्क करें।",

    // Prediction-Specific Elements
    "planetary_periods": "ग्रहों की अवधि (दशा)",
    "mahadasha": "महादशा अवधि",
    "antardasha": "अंतर्दशा उप-अवधि",
    "pratyantar_dasha": "प्रत्यंतर दशा",
    "transit_analysis": "ग्रहों का गोचर",
    "yogas_combinations": "शुभ योग और संयोजन",

    // Life Events Predictions
    "career_milestones": "करियर के मील के पत्थर",
    "job_changes": "नौकरी में बदलाव और पदोन्नति",
    "business_opportunities": "व्यापारिक अवसर",
    "educational_achievements": "शैक्षणिक उपलब्धियां",
    "marriage_timing": "विवाह का समय",
    "childbirth_predictions": "संतान की भविष्यवाणी",
    "property_acquisition": "संपत्ति और रियल एस्टेट",
    "travel_opportunities": "यात्रा और विदेशी अवसर",

    // Career Predictions
    "professional_growth": "व्यावसायिक विकास की समयरेखा",
    "success_periods": "सफलता और मान्यता की अवधि",
    "career_challenges": "करियर चुनौती की अवधि",
    "leadership_roles": "नेतृत्व के अवसर",
    "business_ventures": "व्यापारिक उद्यम की सफलता",
    "financial_growth": "वित्तीय विकास के पैटर्न",

    // Marriage & Relationships
    "love_life_predictions": "प्रेम जीवन की भविष्यवाणी",
    "marriage_compatibility": "विवाह साझीदार अनुकूलता",
    "relationship_timing": "रिश्ते के मील के पत्थर",
    "family_expansion": "पारिवारिक विकास और बच्चे",
    "marital_harmony": "वैवाहिक सद्भावना की अवधि",
    "relationship_challenges": "रिश्ते की चुनौती की अवधि",

    // Wealth & Finance
    "wealth_accumulation": "धन संचय की समयरेखा",
    "investment_success": "निवेश सफलता की अवधि",
    "property_gains": "संपत्ति और परिसंपत्ति लाभ",
    "business_profits": "व्यापारिक लाभ चक्र",
    "financial_setbacks": "वित्तीय चुनौती की अवधि",
    "debt_recovery": "ऋण वसूली और वित्तीय स्थिरता",

    // Health & Longevity
    "health_timeline": "स्वास्थ्य समयरेखा भविष्यवाणी",
    "disease_periods": "स्वास्थ्य चुनौती की अवधि",
    "recovery_periods": "रिकवरी और उपचार की अवधि",
    "longevity_analysis": "दीर्घायु और जीवन काल विश्लेषण",
    "accident_prone_periods": "दुर्घटना प्रवण अवधि",
    "vitality_enhancement": "जीवन शक्ति वृद्धि की अवधि",

    // Family & Social
    "family_events": "पारिवारिक घटनाएं और मील के पत्थर",
    "children_predictions": "बच्चों से संबंधित भविष्यवाणी",
    "parental_health": "माता-पिता का स्वास्थ्य और कल्याण",
    "sibling_relationships": "भाई-बहन के रिश्ते",
    "social_recognition": "सामाजिक स्थिति और मान्यता",
    "community_involvement": "सामुदायिक नेतृत्व की भूमिकाएं",

    // Spiritual & Personal Growth
    "spiritual_awakening": "आध्यात्मिक जागृति की अवधि",
    "religious_inclinations": "धार्मिक और आध्यात्मिक झुकाव",
    "pilgrimage_opportunities": "तीर्थयात्रा और पवित्र यात्राएं",
    "meditation_periods": "ध्यान और आंतरिक विकास",
    "guru_connections": "आध्यात्मिक गुरु कनेक्शन",
    "moksha_path": "मुक्ति और ज्ञान का मार्ग",

    // Timing & Cycles
    "auspicious_periods": "शुभ समय अवधि",
    "challenging_periods": "चुनौतीपूर्ण समय अवधि",
    "neutral_periods": "तटस्थ और स्थिर अवधि",
    "transformation_phases": "प्रमुख परिवर्तन चरण",
    "opportunity_windows": "अवसर की खिड़कियां",
    "decision_making_periods": "इष्टतम निर्णय लेने का समय",

    // Age-Based Predictions
    "childhood_predictions": "बचपन और प्रारंभिक जीवन",
    "teenage_predictions": "किशोरावस्था और युवा भविष्यवाणी",
    "young_adult_phase": "युवा वयस्क चरण (20-35)",
    "middle_age_predictions": "मध्यम आयु भविष्यवाणी (35-55)",
    "senior_years": "वरिष्ठ वर्ष और सेवानिवृत्ति",
    "life_completion": "जीवन पूर्णता और विरासत",

    // Remedies & Solutions
    "planetary_remedies": "ग्रहों के उपाय",
    "gemstone_recommendations": "रत्न सिफारिशें",
    "mantra_chanting": "लाभकारी मंत्र",
    "charity_suggestions": "दान गतिविधियां",
    "ritual_recommendations": "अनुष्ठान और पूजा सिफारिशें",
    "lifestyle_modifications": "जीवनशैली में संशोधन",

    // Advanced Predictions
    "karma_analysis": "कर्म पैटर्न विश्लेषण",
    "past_life_influences": "पूर्व जन्म के प्रभाव",
    "soul_purpose": "आत्मा का उद्देश्य और मिशन",
    "destiny_fulfillment": "भाग्य पूर्ति का मार्ग",
    "life_lessons": "मुख्य जीवन सबक",
    "evolutionary_growth": "विकासवादी आत्मा विकास",

    // Specific Event Timing
    "marriage_age_prediction": "विवाह आयु भविष्यवाणी",
    "first_child_timing": "पहली संतान का समय",
    "career_peak_period": "करियर शिखर अवधि",
    "maximum_wealth_phase": "अधिकतम धन चरण",
    "health_recovery_timing": "स्वास्थ्य रिकवरी का समय",
    "spiritual_realization": "आध्यात्मिक अनुभूति चरण",

    // Global & Environmental
    "foreign_opportunities": "विदेशी यात्रा और अवसर",
    "relocation_predictions": "स्थानांतरण और प्रवास",
    "global_connections": "अंतर्राष्ट्रीय कनेक्शन",
    "cultural_exchanges": "सांस्कृतिक और शैक्षणिक आदान-प्रदान",
    "technology_adaptations": "प्रौद्योगिकी और नवाचार में शामिलता",

    // Detailed Time Frames
    "next_year_predictions": "अगले वर्ष की भविष्यवाणी",
    "next_5_years": "अगले 5 वर्षों का अवलोकन",
    "next_10_years": "अगले दशक का पूर्वानुमान",
    "life_phases": "प्रमुख जीवन चरण",
    "cyclical_patterns": "आवर्तक जीवन पैटर्न",
    "milestone_achievements": "प्रमुख मील के पत्थर की उपलब्धियां"
};
